// extracted by mini-css-extract-plugin
export var fileItem = "FileDetail-module--fileItem--DUSH+";